import {Col, Spinner} from "react-bootstrap";
import TotalSitesAndSystems from "../TotalSitesAndSystems/TotalSitesAndSystems";
import TotalLeaksVolume from "../TotalLeaksVolume/TotalLeaksVolume";
import TotalAlertingSystems from "../TotalAlertingSystems/TotalAlertingSystems";
import TotalLeakAlerts from "../TotalLeakAlerts/TotalLeakAlerts";
import LeakCost from "../LeakCost/LeakCost";
import React, {useEffect, useState} from "react";
import {apolloClientReports} from "../../../GraphQL/config";
import {QUERY_GET_STATS_DATA} from "../../../GraphQL/ReportGenerator/queries";
import {N_LAST_DAYS} from "../../../Constants/constants";
import TotalWaterConsumption from "../TotalWaterConsumption/TotalWaterConsumption";
import {DEFAULT_CURRENCY_UNIT, DEFAULT_VOLUME_UNIT} from "../MeasurementText/MeasurementTextConverter";

export default function StatisticsData(props) {
    const [statsData, setStatsData] = useState();
    const [volumeUnit, setVolumeUnit] = useState(DEFAULT_VOLUME_UNIT);
    const [currencyUnit, setCurrencyUnit] = useState(DEFAULT_CURRENCY_UNIT);

    const queryStatisticsData = () => {
        apolloClientReports.query({
            query: QUERY_GET_STATS_DATA,
            variables: {nLastDays: N_LAST_DAYS}
        }).then(res => {
            const generalInfo = res?.data?.generalInfo;
            if (!generalInfo) {
                console.error(`Data from StatisticsData is empty`);
            } else {
                setVolumeUnit(generalInfo.measureUnit.volumeUnit);
                setCurrencyUnit(generalInfo.cost.currencyUnit);
                setStatsData(generalInfo);
            }
        });
    }

    useEffect(() => {
        queryStatisticsData();
    }, [props.settingsData]);

    return (
        <>
            {(!statsData || !props.settingsData) && <Spinner animation="border" variant="primary"/>}
            {statsData && props.settingsData &&
                <>
                    {/* ============== Total Sites & Systems ============== */}
                    <Col md={1} className={'ColStyle'}>
                        <TotalSitesAndSystems data={statsData}/>
                    </Col>


                    {/* ============== Total Water Consumption ============== */}
                    <Col md={2} className={'ColStyle'}>
                        <TotalWaterConsumption data={statsData} volumeUnit={volumeUnit}/>
                    </Col>

                    {/* ============== Total Leaks Volume ============== */}
                    <Col md={2} className={'ColStyle'}>
                        <TotalLeaksVolume data={statsData} volumeUnit={volumeUnit}/>
                    </Col>

                    {/* ============== Total Alerting Systems ============== */}
                    <Col md={2} className={'ColStyle'}>
                        <TotalAlertingSystems data={statsData}/>
                    </Col>

                    {/* ============== Total Leak Alerts ============== */}
                    <Col md={2} className={'ColStyle'}>
                        <TotalLeakAlerts data={statsData}/>
                    </Col>

                    {/* ============== Leak Cost ============== */}
                    <Col md={3} className={'ColStyle'}>
                        <LeakCost data={statsData} currencyUnit={currencyUnit} volumeUnit={volumeUnit}/>
                    </Col>
                </>
            }
        </>
    )

}